import React, { useState, useEffect, useRef } from 'react';

const Contact = () => {
    const [formData, setFormData] = useState({
        user_name: '',
        user_email: '',
        user_subject: '',
        user__message: ''
    });
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const obs = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) { setVisible(true); obs.disconnect(); }
        }, { threshold: 0.15 });
        if (sectionRef.current) obs.observe(sectionRef.current);
        return () => obs.disconnect();
    }, []);

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // EmailJS configuration from environment variables
            const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_s49ll6k';
            const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_jrj9r27';
            const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'Kg-EjnaLJhsZDRAyl';

            // Import EmailJS dynamically
            const emailjs = await import('emailjs-com');

            // Use the same method as your original code - sendForm with form element
            const form = e.target;
            await emailjs.default.sendForm(serviceID, templateID, form, publicKey);

            // Track successful contact form submission
            if (window.gtag) {
                window.gtag('event', 'contact_form_submit', {
                    event_category: 'engagement',
                    event_label: 'contact_form_success',
                    value: 1
                });
            }

            setMessage('✅ Message sent successfully! I will get back to you soon.');

            // Clear form
            setFormData({
                user_name: '',
                user_email: '',
                user_subject: '',
                user__message: ''
            });

        } catch (error) {
            console.error('EmailJS Error:', error);

            // Track failed contact form submission
            if (window.gtag) {
                window.gtag('event', 'contact_form_error', {
                    event_category: 'engagement',
                    event_label: 'contact_form_failed'
                });
            }

            setMessage('❌ Message not sent. Please try again or contact me directly.');
        } finally {
            setIsLoading(false);
            // Clear message after 5 seconds
            setTimeout(() => {
                setMessage('');
            }, 5000);
        }
    };

    return (
        <section
            className={`contact section${visible ? ' section--visible' : ''}`}
            id="contact"
            ref={sectionRef}
        >
            <div className={`contact__container grid contact-reveal${visible ? ' contact-reveal--visible' : ''}`}>
                <div className="contact__data">
                    <h2 className="section__title-2">
                        <span>Contact Me.</span>
                    </h2>

                    <p className="contact__description-1">
                        I will read all emails. Send me any
                        message you want and I'll get back to you.
                    </p>
                    <p className="contact__description-2">
                        I need your <b>Name</b> and <b>Email Address</b>, but
                        you won't receive anything other than your reply.
                    </p>

                    <div className="geometric-box"></div>
                </div>

                <div className="contact__mail">
                    <h2 className="contact__title">
                        Send Me A Message
                    </h2>

                    <form className="contact__form" id="contact-form" onSubmit={handleSubmit}>
                        <div className="contact__group">
                            <div className="contact__box">
                                <input
                                    type="text"
                                    name="user_name"
                                    className="contact__input"
                                    placeholder="First Name"
                                    value={formData.user_name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="contact__box">
                                <input
                                    type="email"
                                    name="user_email"
                                    className="contact__input"
                                    placeholder="Email Address"
                                    value={formData.user_email}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="contact__box">
                            <input
                                type="text"
                                name="user_subject"
                                className="contact__input"
                                placeholder="Subject"
                                value={formData.user_subject}
                                onChange={handleInputChange}
                                required
                            />
                        </div>

                        <div className="contact__box contact__area">
                            <textarea
                                name="user__message"
                                className="contact__input"
                                placeholder="Message"
                                value={formData.user__message}
                                onChange={handleInputChange}
                                required
                            ></textarea>
                        </div>

                        {message && <p className="contact__message" style={{ color: message.includes('success') ? '#4CAF50' : '#f44336' }}>{message}</p>}

                        <button
                            type="submit"
                            className="contact__button button"
                            disabled={isLoading}
                            style={{ opacity: isLoading ? 0.7 : 1 }}
                        >
                            <i className="ri-send-plane-line"></i>
                            {isLoading ? 'Sending...' : 'Send Message'}
                        </button>
                    </form>
                </div>

                <div className="contact__social">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/curved-arrow.svg`} alt="Contact arrow" className="contact__social-arrow" />

                    <div className="contact__social-data">
                        <div>
                            <p className="contact__social-description-1">
                                Prefer a quicker reply?
                            </p>
                            <p className="contact__social-description-2">
                                Message me on WhatsApp, Instagram, or LinkedIn.
                            </p>
                        </div>

                        <div className="contact__social-links">
                            <a href="https://wa.me/923105049479" target="_blank" rel="noopener noreferrer" className="contact__social-link">
                                <i className="ri-phone-fill"></i>
                            </a>
                            <a href="https://www.instagram.com/haidermasood99" target="_blank" rel="noopener noreferrer" className="contact__social-link">
                                <i className="ri-instagram-line"></i>
                            </a>
                            <a href="https://www.linkedin.com/in/haidermasood99/" target="_blank" rel="noopener noreferrer" className="home__social-link">
                                <i className="ri-linkedin-box-line"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
